import { render } from "./Repository.vue?vue&type=template&id=a7cc1b24"
import script from "./Repository.vue?vue&type=script&lang=ts"
export * from "./Repository.vue?vue&type=script&lang=ts"

import "./Repository.vue?vue&type=style&index=0&id=a7cc1b24&lang=scss"
script.render = render

export default script